import { FeatureFlagKey } from "encamp-shared/src/featureFlags";

import { useFeatureFlags } from "./useFeatureFlags";

/**
 * Gate for the V3 Manifests view, which interleaves manifests and bills of
 * lading in one sortable list.
 *
 * Renders only when `manifest-views-v3` is on for the tenant. This is a
 * separate flag from `waste-epa-document-ingest` (which gates whether EPA
 * documents are warehoused at all — 15 production customers already have
 * that flag on for document warehousing, not for this grid) and from
 * `manifest-views-v2` (the v2 Manifest/Waste Stream rework). The flag is
 * `staffOverride: true`, so `useFeatureFlags` already resolves it to `true`
 * for staff — no explicit `isStaff` check is needed here.
 *
 * Returns `true` when the v3 view should render.
 */
export function useManifestViewsV3(): boolean {
  const { featureFlags } = useFeatureFlags();
  return !!featureFlags[FeatureFlagKey.ManifestViewsV3];
}
